import type { MediaItem } from "@/utils/media";

export const mediaList: MediaItem[] = [
  {
    id: "chunye-weiguang",
    title: "春夜微光",
    type: "movie",
    year: 2024,
    region: "中国",
    director: "林知遥",
    actors: ["苏晚晴", "陆时衍", "沈叙"],
    rating: 9.2,
    tags: ["都市", "治愈", "重逢"],
    shortDesc: "春雨夜里重逢的两个人，用一整季的等待换一次勇敢。",
    synopsis:
      "三年前的误会让他们在同一个雨夜分道扬镳。三年后，建筑师陆时衍回到老城区改造项目，遇见了在旧书店守着青春记忆的苏晚晴。一座即将拆迁的旧影院、一本被翻烂的剧本、一封从未寄出的信，让两人重新走近。春夜的微光下，他们终于承认，那些没有说出口的喜欢，从来都没有消失过。",
    poster:
      "https://readdy.ai/api/search-image?query=Romantic%20film%20poster%20artwork%2C%20soft%20warm%20pastel%20pink%20and%20cream%20color%20palette%2C%20a%20young%20woman%20standing%20under%20spring%20rain%20at%20night%20holding%20a%20book%2C%20dreamy%20blurred%20bokeh%20city%20lights%20background%20with%20gentle%20diffused%20glow%2C%20elegant%20minimal%20composition%20with%20soft%20shadows%2C%20cinematic%20emotional%20mood%2C%20high%20detail%2C%20harmonious%20warm%20tones%2C%20simple%20clean%20backdrop&width=600&height=800&seq=love-movie-01&orientation=portrait",
    updatedAt: "2026-10-08",
    featured: true,
  },
  {
    id: "sheye-diantai",
    title: "深夜电台恋人",
    type: "movie",
    year: 2022,
    region: "中国",
    director: "程野",
    actors: ["顾星禾", "江淮", "易舒"],
    rating: 8.6,
    tags: ["都市", "治愈", "相遇"],
    shortDesc: "深夜电台里，两个陌生声音在电波中慢慢靠近。",
    synopsis:
      "失业的插画师顾星禾成了深夜电台的代班主播，而每晚拨打热线的听众里，总有一个熟悉的声音。他自称“追风的旅人”，讲述着旅途中遇到的遗憾与温柔。直到某天她发现，那个声音的主人就在她每天路过的街角咖啡馆里。深夜的电波把两颗孤独的心连在一起，也让他们学会在现实里勇敢相见。",
    poster:
      "https://readdy.ai/api/search-image?query=Romantic%20film%20poster%20artwork%2C%20soft%20warm%20pastel%20pink%20and%20cream%20color%20palette%2C%20a%20lone%20radio%20microphone%20on%20a%20desk%20with%20warm%20night%20lamp%20glow%20and%20a%20girl%20silhouette%20listening%2C%20dreamy%20blurred%20bokeh%20background%20with%20gentle%20diffused%20light%2C%20elegant%20minimal%20composition%20with%20soft%20shadows%2C%20cinematic%20emotional%20mood%2C%20high%20detail%2C%20harmonious%20warm%20tones%2C%20simple%20clean%20backdrop&width=600&height=800&seq=love-movie-02&orientation=portrait",
    updatedAt: "2026-09-24",
    featured: false,
  },
  {
    id: "bali-laixin",
    title: "巴黎来信",
    type: "movie",
    year: 2023,
    region: "欧美",
    director: "Julien Moreau",
    actors: ["Claire Dubois", "Étienne Roche", "Sophie Laurent"],
    rating: 8.9,
    tags: ["异国", "书信", "浪漫"],
    shortDesc: "一封寄错地址的信，让两个城市的人相遇在塞纳河畔。",
    synopsis:
      "女摄影师克莱尔在整理祖母遗物时发现一叠从未寄出的信，收信地址是巴黎左岸的一间旧书店。她带着信前往巴黎，遇见了守护书店的埃蒂安。两人在寻找信件主人的过程中，重走了祖母年轻时的街道，也各自解开了关于爱与放手的结。塞纳河畔的黄昏下，错位的信终于找到了它该被读到的时刻。",
    poster:
      "https://readdy.ai/api/search-image?query=Romantic%20film%20poster%20artwork%2C%20soft%20warm%20pastel%20pink%20and%20cream%20color%20palette%2C%20a%20couple%20walking%20along%20the%20Seine%20river%20at%20golden%20dusk%20with%20old%20books%20and%20letters%2C%20dreamy%20blurred%20bokeh%20city%20lights%20background%20with%20gentle%20diffused%20light%2C%20elegant%20minimal%20composition%20with%20soft%20shadows%2C%20cinematic%20emotional%20mood%2C%20high%20detail%2C%20harmonious%20warm%20tones%2C%20simple%20clean%20backdrop&width=600&height=800&seq=love-movie-03&orientation=portrait",
    updatedAt: "2026-10-01",
    featured: true,
  },
  {
    id: "yinghua-jijie",
    title: "樱花的季节",
    type: "movie",
    year: 2021,
    region: "日韩",
    director: "中村凉太",
    actors: ["白石凛", "佐藤悠真", "小林葵"],
    rating: 8.4,
    tags: ["校园", "青春", "错过"],
    shortDesc: "高中三年的樱花树下，他们一次次错过又靠近。",
    synopsis:
      "转学生白石凛在樱花盛开的第一天遇见了摄影社的佐藤悠真。此后三年，每一年的花期都记录着他们若即若离的心事：一张没被取走的照片、一场被雨打断的告白、一次擦肩而过的倔强。毕业那天，樱花再次落下，他们终于明白有些喜欢不需要完美时机，只需要一句“我一直都在”。",
    poster:
      "https://readdy.ai/api/search-image?query=Romantic%20film%20poster%20artwork%2C%20soft%20warm%20pastel%20pink%20and%20cream%20color%20palette%2C%20two%20teenagers%20standing%20under%20blooming%20cherry%20blossom%20trees%20with%20petals%20falling%2C%20dreamy%20blurred%20bokeh%20spring%20park%20background%20with%20gentle%20diffused%20light%2C%20elegant%20minimal%20composition%20with%20soft%20shadows%2C%20cinematic%20emotional%20mood%2C%20high%20detail%2C%20harmonious%20warm%20tones%2C%20simple%20clean%20backdrop&width=600&height=800&seq=love-movie-04&orientation=portrait",
    updatedAt: "2026-08-30",
    featured: false,
  },
  {
    id: "haibian-jiuchangpian",
    title: "海边的旧唱片",
    type: "movie",
    year: 2020,
    region: "中国",
    director: "聂怀安",
    actors: ["温言", "周牧", "夏岚"],
    rating: 8.1,
    tags: ["小镇", "怀旧", "重逢"],
    shortDesc: "一张旧唱片，一段被海风吹散的初恋。",
    synopsis:
      "海边小镇唯一的唱片店里，店主温言守着一台老唱机和一段无人知晓的往事。十年后，成为音乐制作人的周牧回到故乡，只为找回当年那张改变他一生的黑胶唱片。海风、潮汐、走音的旋律，把两个错过多年的年轻人重新拉回同一段旋律里。有些歌要听很多遍，才能听懂当年没说出口的话。",
    poster:
      "https://readdy.ai/api/search-image?query=Romantic%20film%20poster%20artwork%2C%20soft%20warm%20pastel%20pink%20and%20cream%20color%20palette%2C%20a%20vintage%20record%20player%20by%20a%20seaside%20shop%20window%20with%20sea%20waves%20outside%2C%20dreamy%20blurred%20bokeh%20sunset%20background%20with%20gentle%20diffused%20light%2C%20elegant%20minimal%20composition%20with%20soft%20shadows%2C%20cinematic%20emotional%20mood%2C%20high%20detail%2C%20harmonious%20warm%20tones%2C%20simple%20clean%20backdrop&width=600&height=800&seq=love-movie-05&orientation=portrait",
    updatedAt: "2026-08-12",
    featured: false,
  },
  {
    id: "diqici-gaobai",
    title: "第七次告白",
    type: "movie",
    year: 2024,
    region: "欧美",
    director: "Emily Carter",
    actors: ["Nora Bennett", "Liam Hayes", "Grace Ford"],
    rating: 8.7,
    tags: ["都市", "欢喜冤家", "浪漫"],
    shortDesc: "她决定第七次告白，如果还是失败就彻底放下。",
    synopsis:
      "咖啡师诺拉喜欢了老友利亚姆六年，前六次告白都阴差阳错地成了笑话。这一次她给自己定了期限：第七次告白，成也好败也好，都要重新开始。可就在她准备的这一周里，利亚姆突然变得格外反常。纽约的秋天很短，短到足够让一个人下定决心，也足够让另一个人终于清醒。",
    poster:
      "https://readdy.ai/api/search-image?query=Romantic%20film%20poster%20artwork%2C%20soft%20warm%20pastel%20pink%20and%20cream%20color%20palette%2C%20a%20young%20couple%20in%20a%20cozy%20autumn%20city%20cafe%20with%20warm%20window%20light%2C%20dreamy%20blurred%20bokeh%20street%20background%20with%20gentle%20diffused%20glow%2C%20elegant%20minimal%20composition%20with%20soft%20shadows%2C%20cinematic%20emotional%20mood%2C%20high%20detail%2C%20harmonious%20warm%20tones%2C%20simple%20clean%20backdrop&width=600&height=800&seq=love-movie-06&orientation=portrait",
    updatedAt: "2026-10-05",
    featured: true,
  },
  {
    id: "yuni-siji",
    title: "与你共度的四季",
    type: "movie",
    year: 2023,
    region: "日韩",
    director: "金敏哲",
    actors: ["韩素妍", "李道贤", "朴志勋"],
    rating: 8.5,
    tags: ["治愈", "生活流", "温柔"],
    shortDesc: "一间民宿，四个季节，两个人慢慢靠近的故事。",
    synopsis:
      "辞去大城市工作的韩素妍回到乡下经营一家小民宿，遇见了每年四季都会来住几天的摄影师李道贤。春天的樱、夏天的雨、秋天的银杏、冬天的初雪，四个季节里他们从陌生到熟悉，从客套到习惯。没有轰轰烈烈的桥段，只有把日子过成诗的温柔。",
    poster:
      "https://readdy.ai/api/search-image?query=Romantic%20film%20poster%20artwork%2C%20soft%20warm%20pastel%20pink%20and%20cream%20color%20palette%2C%20a%20cozy%20countryside%20guesthouse%20surrounded%20by%20four%20season%20scenery%20with%20a%20couple%20on%20the%20porch%2C%20dreamy%20blurred%20bokeh%20background%20with%20gentle%20diffused%20light%2C%20elegant%20minimal%20composition%20with%20soft%20shadows%2C%20cinematic%20emotional%20mood%2C%20high%20detail%2C%20harmonious%20warm%20tones%2C%20simple%20clean%20backdrop&width=600&height=800&seq=love-movie-07&orientation=portrait",
    updatedAt: "2026-09-18",
    featured: false,
  },
  {
    id: "yuji-buzailai",
    title: "雨季不再来",
    type: "movie",
    year: 2019,
    region: "中国",
    director: "沈砚舟",
    actors: ["林溪", "苏牧", "陈念"],
    rating: 7.9,
    tags: ["青春", "遗憾", "成长"],
    shortDesc: "那个漫长的雨季结束后，他们都学会了告别。",
    synopsis:
      "南方小城的高三雨季特别长。林溪和苏牧在同一个屋檐下躲过无数场雨，也在同一间教室里写下彼此的志愿。可高考后的那个夏天，两个人却走向了完全不同的方向。多年后林溪成为作家，把这段没有结局的故事写进书里，也终于明白有些雨季注定要过去，有些人注定要成为记忆里的晴天。",
    poster:
      "https://readdy.ai/api/search-image?query=Romantic%20film%20poster%20artwork%2C%20soft%20warm%20pastel%20pink%20and%20cream%20color%20palette%2C%20two%20students%20sharing%20an%20umbrella%20in%20a%20rainy%20southern%20town%20street%2C%20dreamy%20blurred%20bokeh%20rain%20background%20with%20gentle%20diffused%20light%2C%20elegant%20minimal%20composition%20with%20soft%20shadows%2C%20cinematic%20emotional%20mood%2C%20high%20detail%2C%20harmonious%20warm%20tones%2C%20simple%20clean%20backdrop&width=600&height=800&seq=love-movie-08&orientation=portrait",
    updatedAt: "2026-07-28",
    featured: false,
  },
  {
    id: "wuye-kafeiguan",
    title: "午夜咖啡馆",
    type: "movie",
    year: 2022,
    region: "欧美",
    director: "Marco Rossi",
    actors: ["Elena Russo", "David Kim", "Mia Chen"],
    rating: 8.3,
    tags: ["都市", "治愈", "相遇"],
    shortDesc: "只在午夜营业的咖啡馆里，每个人都在等一个人。",
    synopsis:
      "罗马城里有一间只在午夜营业的咖啡馆。失恋的编剧艾莲娜、赶稿的插画师大卫、寻找旧友的服务生米娅，都在这里讲述自己的故事。老板从不给爱情答案，却总能让每个人在离开时带走一点勇气。当清晨的第一缕光照进来，他们终于愿意走出咖啡馆，去面对那个一直在等的人。",
    poster:
      "https://readdy.ai/api/search-image?query=Romantic%20film%20poster%20artwork%2C%20soft%20warm%20pastel%20pink%20and%20cream%20color%20palette%2C%20a%20cozy%20midnight%20cafe%20with%20warm%20hanging%20lamps%20and%20a%20lone%20cup%20of%20coffee%2C%20dreamy%20blurred%20bokeh%20window%20background%20with%20gentle%20diffused%20light%2C%20elegant%20minimal%20composition%20with%20soft%20shadows%2C%20cinematic%20emotional%20mood%2C%20high%20detail%2C%20harmonious%20warm%20tones%2C%20simple%20clean%20backdrop&width=600&height=800&seq=love-movie-09&orientation=portrait",
    updatedAt: "2026-09-10",
    featured: false,
  },
  {
    id: "guangnian-zhiwai",
    title: "光年之外的爱",
    type: "movie",
    year: 2025,
    region: "中国",
    director: "陆沉",
    actors: ["凌霜", "顾云舟", "季遥"],
    rating: 9.0,
    tags: ["奇幻", "跨越", "浪漫"],
    shortDesc: "她收到了来自十年前的一条短信，发信人是他。",
    synopsis:
      "天文台研究员凌霜收到一条时间戳错乱的短信，发信人是十年前的顾云舟——那个她以为早已消失的人。借助射电望远镜的异常信号，两人开始隔着十年时光通信。她试图改变他的命运，却一次次发现每个选择都会牵动整条时间线。光年之外，是距离，也是爱唯一无法被计算的长度。",
    poster:
      "https://readdy.ai/api/search-image?query=Romantic%20sci-fi%20film%20poster%20artwork%2C%20soft%20warm%20pastel%20pink%20and%20cream%20color%20palette%2C%20a%20woman%20standing%20by%20a%20giant%20radio%20telescope%20under%20a%20starry%20sky%2C%20dreamy%20blurred%20bokeh%20starfield%20background%20with%20gentle%20diffused%20glow%2C%20elegant%20minimal%20composition%20with%20soft%20shadows%2C%20cinematic%20emotional%20mood%2C%20high%20detail%2C%20harmonious%20warm%20tones%2C%20simple%20clean%20backdrop&width=600&height=800&seq=love-movie-10&orientation=portrait",
    updatedAt: "2026-10-10",
    featured: true,
  },
  {
    id: "chulian-bowuguan",
    title: "初恋博物馆",
    type: "movie",
    year: 2021,
    region: "中国",
    director: "许南",
    actors: ["白鹿", "沈亦", "方琪"],
    rating: 8.0,
    tags: ["文艺", "怀旧", "治愈"],
    shortDesc: "一家收藏初恋信物的博物馆，藏着无数个未完成的故事。",
    synopsis:
      "白鹿经营着一家特殊的博物馆，专门收藏人们关于初恋的纪念品：一张电影票、一枚旧纽扣、一只没送出去的手套。每件藏品背后都有一段没说完整的故事。某天，一位年轻人带来了她最熟悉的东西，也让她不得不面对自己那段被妥帖收藏的初恋。有些信物留着不是为了怀念，而是为了道别。",
    poster:
      "https://readdy.ai/api/search-image?query=Romantic%20film%20poster%20artwork%2C%20soft%20warm%20pastel%20pink%20and%20cream%20color%20palette%2C%20a%20museum%20shelf%20displaying%20sentimental%20keepsakes%20like%20tickets%20and%20gloves%20in%20warm%20light%2C%20dreamy%20blurred%20bokeh%20background%20with%20gentle%20diffused%20light%2C%20elegant%20minimal%20composition%20with%20soft%20shadows%2C%20cinematic%20emotional%20mood%2C%20high%20detail%2C%20harmonious%20warm%20tones%2C%20simple%20clean%20backdrop&width=600&height=800&seq=love-movie-11&orientation=portrait",
    updatedAt: "2026-08-05",
    featured: false,
  },
  {
    id: "dongri-xuanlv",
    title: "冬日的旋律",
    type: "movie",
    year: 2023,
    region: "日韩",
    director: "山口遥",
    actors: ["川口結衣", "森田涼", "井上遥"],
    rating: 8.2,
    tags: ["音乐", "治愈", "初雪"],
    shortDesc: "流浪钢琴师与失声歌手，在冬天合奏出一首情歌。",
    synopsis:
      "因声带受损而无法登台的歌手川口结衣，在北海道的小车站遇见了流浪钢琴师森田凉。他弹琴，她在心里唱，两个都失去舞台的人在一间旧音乐教室里重新找到了音乐的意义。初雪落下的那晚，她终于鼓起勇气开口，发现自己的声音其实一直都在，只是需要有人愿意倾听。",
    poster:
      "https://readdy.ai/api/search-image?query=Romantic%20film%20poster%20artwork%2C%20soft%20warm%20pastel%20pink%20and%20cream%20color%20palette%2C%20a%20piano%20in%20an%20old%20music%20room%20with%20snow%20falling%20outside%20the%20window%20and%20warm%20light%2C%20dreamy%20blurred%20bokeh%20winter%20background%20with%20gentle%20diffused%20glow%2C%20elegant%20minimal%20composition%20with%20soft%20shadows%2C%20cinematic%20emotional%20mood%2C%20high%20detail%2C%20harmonious%20warm%20tones%2C%20simple%20clean%20backdrop&width=600&height=800&seq=love-movie-12&orientation=portrait",
    updatedAt: "2026-09-02",
    featured: false,
  },
  {
    id: "xindong-xinhao",
    title: "心动信号",
    type: "tv",
    year: 2024,
    region: "中国",
    director: "周慕白",
    actors: ["许清欢", "江砚", "林知夏", "顾南舟"],
    rating: 9.1,
    tags: ["都市", "甜宠", "职场"],
    shortDesc: "广告公司里的四个年轻人，用一场提案赢回彼此的心。",
    synopsis:
      "新媒体总监许清欢与毒舌创意总监江砚是公司公认的冤家。一次全国提案大赛，把两人和另两位同事绑成一组。熬夜、争吵、互相拆台，也在无数个加班的深夜里，看见了彼此藏起来的温柔。当方案拿到第一名的那天，他们也终于读懂了对方发来的那些“心动信号”。",
    poster:
      "https://readdy.ai/api/search-image?query=Romantic%20TV%20series%20poster%20artwork%2C%20soft%20warm%20pastel%20pink%20and%20cream%20color%20palette%2C%20young%20office%20workers%20working%20late%20in%20a%20warm%20lit%20modern%20office%2C%20dreamy%20blurred%20bokeh%20city%20background%20with%20gentle%20diffused%20light%2C%20elegant%20minimal%20composition%20with%20soft%20shadows%2C%20cinematic%20emotional%20mood%2C%20high%20detail%2C%20harmonious%20warm%20tones%2C%20simple%20clean%20backdrop&width=600&height=800&seq=love-tv-01&orientation=portrait",
    updatedAt: "2026-10-09",
    featured: true,
  },
  {
    id: "women-xiangai-ba",
    title: "我们相爱吧",
    type: "tv",
    year: 2023,
    region: "中国",
    director: "叶辰",
    actors: ["温以宁", "贺知遥", "苏晓", "陈默"],
    rating: 8.8,
    tags: ["都市", "成长", "群像"],
    shortDesc: "三对都市男女，在同一座城市里寻找各自的答案。",
    synopsis:
      "同一栋公寓楼里住着三对不同阶段的情侣：刚在一起的甜蜜、进入瓶颈的疲惫、还有分开多年又重逢的遗憾。他们互相见证，也互相影响。在一次次争吵与和解中，每个人都重新思考了“相爱”这两个字真正的重量。这座城市的灯光很亮，但最温暖的那盏，永远为等你回家的人亮着。",
    poster:
      "https://readdy.ai/api/search-image?query=Romantic%20TV%20series%20poster%20artwork%2C%20soft%20warm%20pastel%20pink%20and%20cream%20color%20palette%2C%20three%20couples%20silhouettes%20in%20a%20cozy%20apartment%20building%20at%20evening%20with%20warm%20windows%2C%20dreamy%20blurred%20bokeh%20city%20background%20with%20gentle%20diffused%20light%2C%20elegant%20minimal%20composition%20with%20soft%20shadows%2C%20cinematic%20emotional%20mood%2C%20high%20detail%2C%20harmonious%20warm%20tones%2C%20simple%20clean%20backdrop&width=600&height=800&seq=love-tv-02&orientation=portrait",
    updatedAt: "2026-09-26",
    featured: false,
  },
  {
    id: "lundun-lianren",
    title: "伦敦恋人",
    type: "tv",
    year: 2022,
    region: "欧美",
    director: "Oliver Grant",
    actors: ["Isabella Reed", "Henry Shaw", "Lucy Adams"],
    rating: 8.6,
    tags: ["异国", "都市", "浪漫"],
    shortDesc: "在伦敦的多雨季节里，两个异乡人学会了相爱。",
    synopsis:
      "来自上海的交换生伊莎贝拉与本地建筑师亨利在伦敦的一场雨里相遇。文化差异、签证压力、各自未完成的过去，让这段感情走得并不轻松。他们在地铁站争吵，在泰晤士河边和好，在无数次分别与重逢中确认彼此。当伦敦终于放晴，他们决定把两个原本不同的世界，过成同一个家。",
    poster:
      "https://readdy.ai/api/search-image?query=Romantic%20TV%20series%20poster%20artwork%2C%20soft%20warm%20pastel%20pink%20and%20cream%20color%20palette%2C%20a%20couple%20under%20one%20umbrella%20near%20London%20Thames%20with%20Big%20Ben%20in%20soft%20dusk%2C%20dreamy%20blurred%20bokeh%20city%20background%20with%20gentle%20diffused%20light%2C%20elegant%20minimal%20composition%20with%20soft%20shadows%2C%20cinematic%20emotional%20mood%2C%20high%20detail%2C%20harmonious%20warm%20tones%2C%20simple%20clean%20backdrop&width=600&height=800&seq=love-tv-03&orientation=portrait",
    updatedAt: "2026-09-05",
    featured: false,
  },
  {
    id: "dongjing-aiqing-gushi2",
    title: "东京爱情故事·续",
    type: "tv",
    year: 2021,
    region: "日韩",
    director: "山田惠介",
    actors: ["木村纱英", "高桥凉也", "松下优子"],
    rating: 8.4,
    tags: ["都市", "现实", "成长"],
    shortDesc: "十年后重逢的他们，终于要面对当年没说出口的答案。",
    synopsis:
      "十年前在东京分别的两个人，在同一家公司意外重逢。木村纱英已经是独当一面的企划主管，高桥凉也成了带着女儿生活的单亲父亲。旧情、现实、责任交织在一起，他们小心翼翼地重新靠近，又害怕重蹈覆辙。东京的夜景依旧璀璨，只是这一次，他们都不想再错过。",
    poster:
      "https://readdy.ai/api/search-image?query=Romantic%20TV%20series%20poster%20artwork%2C%20soft%20warm%20pastel%20pink%20and%20cream%20color%20palette%2C%20two%20adults%20meeting%20again%20on%20a%20Tokyo%20street%20at%20night%20with%20warm%20neon%20glow%2C%20dreamy%20blurred%20bokeh%20city%20background%20with%20gentle%20diffused%20light%2C%20elegant%20minimal%20composition%20with%20soft%20shadows%2C%20cinematic%20emotional%20mood%2C%20high%20detail%2C%20harmonious%20warm%20tones%2C%20simple%20clean%20backdrop&width=600&height=800&seq=love-tv-04&orientation=portrait",
    updatedAt: "2026-08-22",
    featured: false,
  },
  {
    id: "yiai-weiyin",
    title: "以爱为营",
    type: "tv",
    year: 2024,
    region: "中国",
    director: "陆昭",
    actors: ["阮清", "谢言", "白薇", "程朗"],
    rating: 8.9,
    tags: ["职场", "甜宠", "欢喜冤家"],
    shortDesc: "财经记者与投行精英的对弈，从针锋相对开始。",
    synopsis:
      "财经记者阮清为了挖到独家新闻，盯上了最难搞的投行精英谢言。采访、交锋、互相设局，两人谁也占不到上风。可当他们一起揭开一家公司的黑幕，并肩走过最危险的那段日子后，才发现对手也可以是战友。商业世界的规则很冷，但两个人的心是热的。",
    poster:
      "https://readdy.ai/api/search-image?query=Romantic%20TV%20series%20poster%20artwork%2C%20soft%20warm%20pastel%20pink%20and%20cream%20color%20palette%2C%20a%20sharp%20businesswoman%20and%20man%20facing%20each%20other%20in%20a%20glass%20office%20with%20warm%20light%2C%20dreamy%20blurred%20bokeh%20background%20with%20gentle%20diffused%20glow%2C%20elegant%20minimal%20composition%20with%20soft%20shadows%2C%20cinematic%20emotional%20mood%2C%20high%20detail%2C%20harmonious%20warm%20tones%2C%20simple%20clean%20backdrop&width=600&height=800&seq=love-tv-05&orientation=portrait",
    updatedAt: "2026-10-07",
    featured: true,
  },
  {
    id: "suiyue-qingshu",
    title: "岁月情书",
    type: "tv",
    year: 2020,
    region: "中国",
    director: "苏怀瑾",
    actors: ["林婉", "顾亭之", "周砚", "许晴"],
    rating: 8.3,
    tags: ["年代", "书信", "温情"],
    shortDesc: "跨越四十年的两地书信，写尽一代人的爱情。",
    synopsis:
      "上世纪七十年代，知青林婉与顾亭之在北方农场相识，却因时代与命运被迫分开。此后四十年，两人靠书信维系着若有若无的联系。信件里有生活、有思念、有各自的家庭，也有从未断过的牵挂。当子孙辈整理出这叠厚厚的信笺时，一段沉默而深情的爱情故事终于被完整地讲述出来。",
    poster:
      "https://readdy.ai/api/search-image?query=Romantic%20period%20TV%20series%20poster%20artwork%2C%20soft%20warm%20pastel%20pink%20and%20cream%20color%20palette%2C%20stack%20of%20old%20handwritten%20letters%20and%20a%20vintage%20bicycle%20in%20warm%20sunlight%2C%20dreamy%20blurred%20bokeh%20nostalgic%20background%20with%20gentle%20diffused%20light%2C%20elegant%20minimal%20composition%20with%20soft%20shadows%2C%20cinematic%20emotional%20mood%2C%20high%20detail%2C%20harmonious%20warm%20tones%2C%20simple%20clean%20backdrop&width=600&height=800&seq=love-tv-06&orientation=portrait",
    updatedAt: "2026-07-30",
    featured: false,
  },
  {
    id: "jiazhuang-qinglv",
    title: "假装情侣",
    type: "tv",
    year: 2023,
    region: "中国",
    director: "何夕",
    actors: ["乔安", "宋屿", "夏木", "林一"],
    rating: 8.2,
    tags: ["都市", "甜宠", "假戏真做"],
    shortDesc: "为应付家长而约定的假情侣，却先一步动了真心。",
    synopsis:
      "被家里催婚催到崩溃的乔安，和同样被逼相亲的宋屿达成协议，假扮情侣应付双方家长。从回家过年开始，两家的聚会、亲戚的盘问、假装的亲密，让这场表演越来越难以收场。当某一次假装的拥抱里，两个人都听见了彼此真实的心跳，这场戏就再也演不下去了。",
    poster:
      "https://readdy.ai/api/search-image?query=Romantic%20TV%20series%20poster%20artwork%2C%20soft%20warm%20pastel%20pink%20and%20cream%20color%20palette%2C%20a%20young%20couple%20awkwardly%20posing%20like%20a%20couple%20in%20a%20warm%20family%20dining%20room%2C%20dreamy%20blurred%20bokeh%20background%20with%20gentle%20diffused%20light%2C%20elegant%20minimal%20composition%20with%20soft%20shadows%2C%20cinematic%20emotional%20mood%2C%20high%20detail%2C%20harmonious%20warm%20tones%2C%20simple%20clean%20backdrop&width=600&height=800&seq=love-tv-07&orientation=portrait",
    updatedAt: "2026-09-14",
    featured: false,
  },
  {
    id: "xiazhi-weizhi",
    title: "夏至未至的告白",
    type: "tv",
    year: 2022,
    region: "中国",
    director: "顾南",
    actors: ["池夏", "言川", "沈知", "温瑶"],
    rating: 8.0,
    tags: ["校园", "青春", "暗恋"],
    shortDesc: "高中的最后一个夏天，他们终于说出了藏了三年的话。",
    synopsis:
      "池夏暗恋同桌言川整整三年，把每一句话都写进日记里，却始终不敢说出口。高三的最后一个夏天，班级组织毕业旅行，一场突如其来的暴雨让他们被困在古镇的小旅馆里。窗外雨声很大，心里的声音更大。青春最美好的部分，或许就是终于鼓起勇气的那一刻。",
    poster:
      "https://readdy.ai/api/search-image?query=Romantic%20TV%20series%20poster%20artwork%2C%20soft%20warm%20pastel%20pink%20and%20cream%20color%20palette%2C%20two%20students%20in%20a%20sunlit%20classroom%20with%20summer%20breeze%20and%20curtains%2C%20dreamy%20blurred%20bokeh%20background%20with%20gentle%20diffused%20light%2C%20elegant%20minimal%20composition%20with%20soft%20shadows%2C%20cinematic%20emotional%20mood%2C%20high%20detail%2C%20harmonious%20warm%20tones%2C%20simple%20clean%20backdrop&width=600&height=800&seq=love-tv-08&orientation=portrait",
    updatedAt: "2026-08-18",
    featured: false,
  },
  {
    id: "hancheng-zhilian",
    title: "汉城之恋",
    type: "tv",
    year: 2021,
    region: "日韩",
    director: "朴敏俊",
    actors: ["张恩熙", "崔延宇", "金多美"],
    rating: 8.5,
    tags: ["都市", "治愈", "异国"],
    shortDesc: "在异国打拼的两个年轻人，把孤独过成了依靠。",
    synopsis:
      "到首尔学设计的张恩熙和做独立音乐的崔延宇，在同一间合租屋里相遇。语言不通、梦想遥远、生活拮据，他们靠彼此的陪伴熬过最难的日子。从便利店的宵夜到深夜的天台，从陌生人的善意到恋人的默契，这座陌生的城市因为有了对方，才终于有了温度。",
    poster:
      "https://readdy.ai/api/search-image?query=Romantic%20TV%20series%20poster%20artwork%2C%20soft%20warm%20pastel%20pink%20and%20cream%20color%20palette%2C%20two%20young%20people%20on%20a%20rooftop%20overlooking%20a%20Korean%20city%20at%20dusk%20with%20warm%20lights%2C%20dreamy%20blurred%20bokeh%20background%20with%20gentle%20diffused%20glow%2C%20elegant%20minimal%20composition%20with%20soft%20shadows%2C%20cinematic%20emotional%20mood%2C%20high%20detail%2C%20harmonious%20warm%20tones%2C%20simple%20clean%20backdrop&width=600&height=800&seq=love-tv-09&orientation=portrait",
    updatedAt: "2026-08-09",
    featured: false,
  },
  {
    id: "manhadun-qingyuan",
    title: "曼哈顿情缘",
    type: "tv",
    year: 2023,
    region: "欧美",
    director: "Rachel Stone",
    actors: ["Amelia Ford", "Noah Blake", "Olivia Reed"],
    rating: 8.7,
    tags: ["都市", "职场", "浪漫"],
    shortDesc: "两个在纽约打拼的陌生人，因为一只流浪猫认识。",
    synopsis:
      "律师助理艾米莉亚和创业者诺亚在同一栋公寓楼下喂养同一只流浪猫，却总在错开的时间出现。一罐猫粮、一张便签、一场意外的大停电，让两人开始真正认识彼此。曼哈顿的生活很快，快到很多人来不及了解；但有些人值得你放慢脚步，认真去爱。",
    poster:
      "https://readdy.ai/api/search-image?query=Romantic%20TV%20series%20poster%20artwork%2C%20soft%20warm%20pastel%20pink%20and%20cream%20color%20palette%2C%20two%20young%20adults%20meeting%20near%20a%20cat%20outside%20a%20Manhattan%20apartment%20with%20warm%20evening%20light%2C%20dreamy%20blurred%20bokeh%20city%20background%20with%20gentle%20diffused%20glow%2C%20elegant%20minimal%20composition%20with%20soft%20shadows%2C%20cinematic%20emotional%20mood%2C%20high%20detail%2C%20harmonious%20warm%20tones%2C%20simple%20clean%20backdrop&width=600&height=800&seq=love-tv-10&orientation=portrait",
    updatedAt: "2026-09-21",
    featured: false,
  },
  {
    id: "banshitang",
    title: "半是蜜糖半是伤",
    type: "tv",
    year: 2025,
    region: "中国",
    director: "纪岑",
    actors: ["姜黎", "傅斯年", "云舒", "陆峥"],
    rating: 8.9,
    tags: ["都市", "虐恋", "成长"],
    shortDesc: "重逢的旧爱成了她的上司，甜与痛各占一半。",
    synopsis:
      "姜黎入职新公司的第一天，发现自己的顶头上司正是当年不告而别的初恋傅斯年。工作上他严苛到近乎冷酷，私下里却总在关键时刻替她兜底。随着当年分开的真相一点点浮出水面，姜黎才发现，有些伤害背后藏着最深的心意。蜜糖与伤，从来都是一体的两面。",
    poster:
      "https://readdy.ai/api/search-image?query=Romantic%20TV%20series%20poster%20artwork%2C%20soft%20warm%20pastel%20pink%20and%20cream%20color%20palette%2C%20a%20woman%20and%20her%20boss%20standing%20in%20a%20modern%20office%20with%20warm%20window%20light%20and%20longing%20gaze%2C%20dreamy%20blurred%20bokeh%20background%20with%20gentle%20diffused%20glow%2C%20elegant%20minimal%20composition%20with%20soft%20shadows%2C%20cinematic%20emotional%20mood%2C%20high%20detail%2C%20harmonious%20warm%20tones%2C%20simple%20clean%20backdrop&width=600&height=800&seq=love-tv-11&orientation=portrait",
    updatedAt: "2026-10-11",
    featured: true,
  },
  {
    id: "shiguang-jiaohui",
    title: "时光教会我爱你",
    type: "tv",
    year: 2024,
    region: "中国",
    director: "罗清让",
    actors: ["祝星", "顾南城", "苏木", "唐棠"],
    rating: 8.6,
    tags: ["治愈", "成长", "慢热"],
    shortDesc: "在快节奏的都市里，他们用了十年学会慢慢相爱。",
    synopsis:
      "祝星和顾南城从大学同学到职场同事，兜兜转转十年，始终没能真正走到一起。她习惯轰轰烈烈，他偏爱细水长流，两种节奏让彼此不断错过。直到一次意外让祝星不得不放慢脚步，她才终于看清，那个一直不声不响陪在她身边的人，早就把爱写进了每一天里。",
    poster:
      "https://readdy.ai/api/search-image?query=Romantic%20TV%20series%20poster%20artwork%2C%20soft%20warm%20pastel%20pink%20and%20cream%20color%20palette%2C%20a%20couple%20walking%20slowly%20through%20a%20changing%20city%20through%20seasons%20with%20warm%20light%2C%20dreamy%20blurred%20bokeh%20background%20with%20gentle%20diffused%20glow%2C%20elegant%20minimal%20composition%20with%20soft%20shadows%2C%20cinematic%20emotional%20mood%2C%20high%20detail%2C%20harmonious%20warm%20tones%2C%20simple%20clean%20backdrop&width=600&height=800&seq=love-tv-12&orientation=portrait",
    updatedAt: "2026-10-03",
    featured: false,
  },
];